import gql from 'graphql-tag'

export default gql`
fragment CashBookSettingsMain on CashBookSettings {
	description
	shouldAccount
	haveAccount
	tax
	taxAmount
	type
}
`
